import React, { Fragment } from "react";
import { PageHero } from "../../components/Global/PageHero";
import { BackToTop } from "../../templates/BackToTop";
import { yearlyItems } from "../../utils/YearlyData";

export const YearlyProgram = () => (
  <Fragment>
    <PageHero
      eyebrow="Church Calendar"
      title="Yearly"
      highlight="Programs"
      subtitle="A full overview of annual events and programs at CCC Salvation Parish."
    />

    <div className="overflow-x-auto relative shadow-xl sm:rounded-lg py-12 px-2 md:px-2 lg:px-20 mx-auto mb-12">
      <table className="w-full text-sm text-left px-12">
        <thead className="text-xs uppercase bg-custom">
          <tr>
            <th scope="col" className="py-3 px-6 text-secondary font-aref text-2xl">
              Events
            </th>
            <th scope="col" className="py-3 px-6 font-aref text-secondary text-2xl">
              Period
            </th>
          </tr>
        </thead>
        {yearlyItems.map((event, index) => (
          <tbody key={index}>
            <tr className="bg-white border-b border-2 text-primary">
              <th scope="row" className="py-4 px-6 capitalize font-bold text-secondary whitespace-nowrap font-abel text-xl">
                {event.program}
              </th>
              <td className="py-4 px-6 font-abel text-lg capitalize">
                {event.period}
              </td>
            </tr>
          </tbody>
        ))}
      </table>
    </div>
    <BackToTop />
  </Fragment>
);
